import React from "react";
import amazon from "../logos/amazon.jpg";
import { Link, useNavigate } from "react-router-dom";
export default function Login(props) {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setEmail(email);
    navigate("/dashboard");
  };
  return (
    <div className="signup-page login-page">
      <img src={amazon} alt="" className="amazon-logo" />
      <form className="signup-form" onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          required
          className="input-field"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <span className="red-text"></span>
        <label htmlFor="password">Password</label>
        <input type="password" id="password" className="input-field" required />
        <p className="form-text">
          Don't have an Account
          <Link className="link" to="/signup">
            Sign Up
          </Link>
        </p>
        <button className="btn btn-continue">Login</button>
      </form>
    </div>
  );
}
